import { NativeDateAdapter } from "@angular/material/core";
import * as moment from 'moment';

export class CustomDateAdapter extends NativeDateAdapter {

	public parse(value: string): Date {
		const result = moment(value, ['L', 'LL', 'D MMM YYYY']);
		return !!result && result.isValid() ? result.toDate() : new Date();
	}
}